export default __webpack_public_path__ + "static/media/About-Tower-viajes-3.152db4d7.jpg";